import { imageUrl } from '@/data/site';

// Svi projekti su iz stvarnih fotografija Garmondovih radova.
// Nazivi su opisni (ne navode klijente); po želji ih zamijeniti stvarnim nazivima projekata.

// Kandidat za hero fotografiju — potvrditi ili zamijeniti.
export const HERO_IMAGE = {
  galleryId: '023.jpg',
  src: imageUrl('0-02-05-7d578fb8b38602e7165252c3970d4465c365d27293ca84f0ef062e8ee033270b_d7042770.jpg'),
  alt: 'Brendirani event prostor s postavljenim grafikama i štandom',
};

export const PROJECTS = [
  {
    id: 'sajamski-stand',
    galleryId: '049.jpg',
    title: 'Sajamski štand',
    category: 'Event i promotivna oprema',
    description: 'Štand s grafikama po cijeloj površini i pultom.',
    image: '/images/gallery/large/049.jpg',
    alt: 'Brendirani sajamski štand s velikim štampanim grafikama i pultom',
    span: 'lg:col-span-7',
    ratio: 'aspect-[3/2]',
  },
  {
    id: 'stakleni-ulaz',
    galleryId: '008.jpg',
    title: 'Folije na staklenim površinama',
    category: 'Veliki formati i outdoor',
    description: 'Grafike na ulaznim staklenim površinama objekta.',
    image: imageUrl('0-02-05-407530296a738aec37309625b240683ece4576546624066fec08608904e161b2_e017a46f.jpg'),
    alt: 'Staklena ulazna vrata prekrivena brendiranim folijama',
    span: 'lg:col-span-5',
    ratio: 'aspect-[3/2] lg:aspect-auto lg:h-full',
  },
  {
    id: 'zidna-grafika',
    galleryId: '118.jpg',
    title: 'Zidna grafika u poslovnom prostoru',
    category: 'Brendiranje prostora i objekata',
    description: 'Štampana zidna grafika koja daje prostoru prepoznatljiv karakter.',
    image: imageUrl('Mazars zidna tapeta.jpg'),
    alt: 'Zidna grafika iznad sofe u poslovnom prostoru',
    span: 'lg:col-span-4',
    ratio: 'aspect-[4/3]',
  },
  {
    id: 'vozilo',
    galleryId: '063.jpg',
    title: 'Brendiranje automobila',
    category: 'Brendiranje vozila',
    description: 'Folija i print prilagođeni formi vozila.',
    image: imageUrl('240279303_4657154211037333_576224155886976162_n.jpg'),
    alt: 'Automobil prekriven brendiranom folijom',
    span: 'lg:col-span-4',
    ratio: 'aspect-[4/3]',
  },
  {
    id: 'svjetleci-paneli',
    galleryId: '015.jpg',
    title: 'Svjetleći paneli',
    category: 'Brendiranje prostora i objekata',
    description: 'Osvijetljene grafike velikog formata u trgovačkom centru.',
    image: imageUrl('0-02-05-583ccdf47f4a9abd92ccc5898671e853b2744931fa117c4cd704cba2332213e2_27d32a6a.jpg'),
    alt: 'Svjetleći panel velikog formata u trgovačkom centru',
    span: 'lg:col-span-4',
    ratio: 'aspect-[4/3]',
  },
  {
    id: 'dresovi',
    galleryId: '021.jpg',
    title: 'Dresovi i promotivni tekstil',
    category: 'Tekstil i radna odjeća',
    description: 'Printani dresovi i majice izrađeni po mjeri.',
    image: imageUrl('0-02-05-799aded7520985efe51dd444ad9569edb6bbfac01da03922ec424b8fe02a1add_397ecb49.jpg'),
    alt: 'Printani sportski dresovi na vješalicama',
    span: 'lg:col-span-5',
    ratio: 'h-64 sm:h-80',
  },
  {
    id: 'press-wall',
    galleryId: '126.jpg',
    title: 'Press wall za konferenciju',
    category: 'Posebna i protokolarna rješenja',
    description: 'Brendirana pozadina za medijska obraćanja.',
    image: imageUrl('b_240311028.webp'),
    alt: 'Press konferencija ispred štampane brendirane pozadine',
    span: 'lg:col-span-7',
    ratio: 'h-64 sm:h-80',
  },
];
